'use strict';

var Emitter = require('cjs-emitter'),
    system = new Emitter();


module.exports = system;
